import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { Environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class IntermediaryService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.APIM_BASE_URL + '/mestplace-v2-service';

  getIntermediaries(): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}/intermediaries`);
  }
}
